export default __webpack_public_path__ + "6fd1df1ff5532237fd3da424a1879531.svg";